import { css } from 'styled-components';

const styles = {
    container: () => css`
        position: relative;
        background-color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 608px;
        width: 100%;
    `,
    icon: () => css`
        position: absolute;
        pointer-events: none;
        left: 0px;
        transform: translateX(-50%);
    `,
    texto: () => css`
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    `,
};

export default styles;
